import { trim } from 'ramda'
import Debug from 'debug'
const debug = Debug('app:settings:billinginfo')
import '../settings.css'
import './billing-info.css'

class BillingInfoController {
  /* @ngInject */
  constructor (company, Auth, CompaniesService, ToastService, Companies, $mdToast) {
    this.company = company
    Auth.getDetails().then(user => this.user = user);
    this.$mdToast = $mdToast;
    this.showBillingRates = false;
    this.company.additionalEmailsString = this.company.additionalEmails
      ? this.company.additionalEmails.join(',')
      : ""
    this.CompaniesService = CompaniesService
    this.ToastService = ToastService
    this.Days = [
        { val: "0", name: '' },
        { val: "3", name: 'WEDNESDAY' }
    ];
    // Must make string or angular adds another select option
    this.company.invoiceDay = "0";
    Companies.fetchBillerClient(this.company.id)
      .then((info) => {
        if (info.length > 0) {
          this.setInfo(info[0]);
          this.setBillerInfo(info[0] && info[0].plan);
        }
      });

    this.pricingTemplates = {
      // Standard HOURLY_MARKUP, pricing_type = 0
      0: {
        label: 'Standard markup:',
        midLabel: (markup) => `${this.getMarkupPercentage(markup)}%`,
        rightLabel: (markup) => `${markup} x hourly wage`,
      },
      // BILL_RATE, pricing_type = 1
      1: {
        label: 'Per shift pricing:',
        midLabel: (markup) => `$${markup} / worker / shift`,
        rightLabel: (markup) => ``,
      },
      // FLAT_DAILY_FEE, pricing_type = 4
      4: {
        label: 'Flat hourly bill rate:',
        midLabel: (markup) => `$${markup} / hour with a locked wage`,
        rightLabel: (markup) => ``,
      },
      // HOURLY_MARKUP / HOSTED_MEMBER, pricing_type = 8
      8: {
        label: 'Variable markup:',
      },
    };
  }

  setBillerInfo(plans) {
    if (plans && plans.length) {
      const now = new Date();
      this.showBillingRates = true;

      // Get only plans with member_type === CREW_MEMBER, not HOSTED_MEMBER
      // biller should support a flag on the get plans call to only return current but
      // until then we need to sort on ui

      const crewMemberPlans = plans
        .filter(r => r.member_type === 'CREW_MEMBER' && r.effective_date && (Date.parse(r.effective_date) < now))
        .sort((a, b) => Date.parse(b.effective_date) - Date.parse(a.effective_date));

      const currentPlan = crewMemberPlans && crewMemberPlans.length ? crewMemberPlans[0] : null;
      if (currentPlan !== null) {
        // First find crew member plan (regular) rates.
        if (currentPlan.plan_type === 'BILL_RATE') {
          this.company.markup = currentPlan.value;
          this.company.pricing_type = 1;
          this.pricingType = 1;
        } else if (currentPlan.plan_type === 'FLAT_DAILY_FEE') {
          this.company.markup = currentPlan.value;
          this.company.pricing_type = 4;
          this.pricingType = 4;
        } else {
          // For hourly_markup plan type we need to figure out
          // if we should select standard markup (type = 0) or variable markup (type = 8).
          // If overtime or double time is set that means they entered variable markups, so set pricing type to 8.
          // If not set then set pricing_type to 0 so 'Standard markup'.
          if (((currentPlan.value_overtime && currentPlan.value_overtime !== 0)) ||
            ((currentPlan.value_doubletime && currentPlan.value_doubletime !== 0))) {
            this.company.vmarkup = currentPlan.value;
            this.company.vmarkupOt = currentPlan.value_overtime;
            this.company.vmarkupDt = currentPlan.value_doubletime;
            this.company.pricing_type = 8;
            this.pricingType = 8;
          } else {
            this.company.markup = currentPlan.value;
            this.company.pricing_type = 0;
            this.pricingType = 0;
          }
        }
      }
      // Check if there is a hosted plan for this company with variable markup
      const hostedPlans = plans
              .filter(r => r.member_type === 'HOSTED_MEMBER' && r.effective_date && (Date.parse(r.effective_date) < now))
              .sort((a, b) => Date.parse(b.effective_date) - Date.parse(a.effective_date));

      // Select latest hosted plan
      const currentHostedPlan = hostedPlans && hostedPlans.length ? hostedPlans[0] : null;
      if ((currentHostedPlan !== null && currentHostedPlan.value && currentHostedPlan.value !== 0)) {
        this.company.vmarkupHosted = currentHostedPlan.value;
        this.company.vmarkupHostedOt = currentHostedPlan.value_overtime;
        this.company.vmarkupHostedDt = currentHostedPlan.value_doubletime;
        this.showHosted = true;
      }
    }
  };

  getMarkupPercentage(num) {
    // The markup value in our system is expressed as a multiplier (e.g. 1.25),
    // output examples: 1.2 === 20%; 1.25 === 25%; 1.325 === 32.5%;
    // Return num if it's whole number
    if (Number.isInteger(num)) return num;
    // Get number as a string splited by decimal point
    const numInDecimals = num.toString().split('.');
    // Get left side of decimal
    const ones = numInDecimals[0];
    // Get right side of decimal
    const decimal = numInDecimals[1];
    // Convert string to number
    let markupNumber = `.${decimal}` * 100;
    if (ones > 0) {
      markupNumber += (`${ones}`-1) * 100;
    }
    if (!Number.isInteger(markupNumber)) {
      // If markupNumber is decimal set fixed-point notation.
      // E.g. we should prevent this: 1.234 => 23.400000000000002
      markupNumber = markupNumber.toFixed(2);
    }
    return Number(markupNumber);
  };

  setInfo(info) {
    if (info.contact) {
      this.company.purchaseOrder = info.contact.purchaseOrder;
      this.company.primaryContactEmail = info.contact.email;
      if (info.contact.additionalEmails){
        this.company.additionalEmailsString = info.contact.additionalEmails.join(',');
      }
      if (info.contact.firstname) {
        this.company.primaryContactFirstName = info.contact.firstname;
      }
      if (info.contact.lastname) {
        this.company.primaryContactLastName = info.contact.lastname;
      }
    }
    if (info.payment && info.payment.invoiceDay) {
      this.company.invoiceDay = info.payment.invoiceDay.toString();
    }
  }

  update () {
    if (this.company.primaryContactEmail.length + this.company.additionalEmails.length > 100) {
      this.ToastService.showError(null, 'Combined primary and additional emails length should not exceed 100 characters')
      return
    }

    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (!re.test(this.company.primaryContactEmail.toLowerCase())) {
      this.ToastService.showWarning('Invalid primary email.')
      return
    }

    let additionalEmails = []

    if (this.company.additionalEmailsString.length > 0) {
      additionalEmails = this.company.additionalEmailsString.split(',').map(email => trim(email))

      for (let i = 0; i < additionalEmails.length; i++) {
        if (!re.test(additionalEmails[i].toLowerCase())) {
          this.ToastService.showWarning('Invalid additional email.')
          return
        }
      }
    }

    this.CompaniesService.updateBillingInfo(
      this.company.internal_id,
      this.company.primaryContactFirstName,
      this.company.primaryContactLastName,
      this.company.primaryContactEmail,
      additionalEmails,
      this.company.purchaseOrder,
      this.company.invoiceDay
    )
    .then(
      this.CompaniesService.updateCompany({
        companyInfo: {
          id: this.company.id,
          has_past_due_invoices: this.company.has_past_due_invoices
        }
      })
    )
    .then(() => {
      this.ToastService.showSuccess('Successfully updated billing info')
      this.company.additionalEmails = additionalEmails
    },
      error => this.ToastService.showError(error, 'Unable to update billing info.')
    )
  }
}

export default BillingInfoController
